import React from 'react';
import { useNavigate } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { 
    FaArrowLeft, 
    FaPrint
} from 'react-icons/fa';

const EngineerGenerateCertificate = () => {
    const navigate = useNavigate();

    const handlePrint = () => {
        window.print();
    };

    return (
        <EngineerLayout>
            <div className="p-6 md:p-8 bg-gray-50/50 min-h-screen">
                {/* Header Section */}
                <div className="flex justify-between items-center mb-8 px-2 font-marathi no-print">
                    <div className="flex items-center gap-4">
                        <button 
                            onClick={() => navigate(-1)}
                            className="p-2 bg-white rounded-full shadow-sm hover:bg-gray-50 transition text-gray-600 border border-gray-100"
                        >
                            <FaArrowLeft size={16} />
                        </button>
                        <h1 className="text-xl font-bold text-gray-800">View Generate Certificate</h1>
                    </div>
                    <div className="text-xs font-medium text-gray-400">
                        Zilla Parishad / <span className="text-gray-500 font-bold uppercase tracking-wider">View Generate Certificate</span>
                    </div>
                </div>

                {/* Certificate Section (Printable) */}
                <div className="bg-white rounded-xl shadow-2xl border border-gray-50 p-[2rem] md:p-[4rem] max-w-5xl mx-auto print-container overflow-hidden">
                    <div className="no-print flex justify-end mb-8 text-left">
                         <button 
                            onClick={handlePrint}
                            className="bg-[#6366f1] hover:bg-[#4f46e5] text-white px-8 py-2.5 rounded-lg font-bold shadow-lg shadow-indigo-500/20 transition transform active:scale-95 flex items-center gap-2 uppercase text-xs"
                        >
                            <FaPrint /> Print
                        </button>
                    </div>

                    {/* Official Letterhead */}
                    <div className="text-center mb-2">
                        <div className="flex justify-center mb-4">
                            <img src="/pune_zp_logo.png" alt="Zilla Parishad Logo" className="h-24 w-auto object-contain" onError={(e) => e.target.src = "https://ekamwatapzp.punecorp.in/static/media/zp_logo.c81f7f02.png"} />
                        </div>
                        <h2 className="text-2xl font-bold text-gray-900 font-marathi">पुणे जिल्हा परिषद पुणे</h2>
                        <h3 className="text-xl font-bold text-gray-800 font-marathi">बांधकाम उत्तर विभाग</h3>
                        <p className="text-lg font-bold text-gray-700 font-marathi leading-relaxed">यशवंतराव चव्हाण भवन, वेलस्ली रोड, कॅम्प, पुणे - ४११००१.</p>
                        <p className="text-lg font-bold text-gray-700 font-marathi">बांधकाम (उत्तर) विभाग, ४ था मजला</p>
                    </div>

                    {/* References & Date */}
                    <div className="mt-8 space-y-2 font-marathi text-sm font-bold text-gray-800 text-left">
                        <div className="space-y-1">
                            <p>वाचा-</p>
                            <p>१) महाराष्ट्र शासन सार्वजनिक बांधकाम विभागाकडील शासन निर्णय क्रमांक.सीएटी २०१७/प्रक्र्.१०३/इमा.२ दिनांक २३.७.१८</p>
                            <p>२) मा.अतिरिक्त मुख्यकार्यकारी अधिकारी जि.प.पुणे यांची मान्य टिपणी दिनांक - ०१/०१/१९७०</p>
                        </div>
                        <div className="flex justify-between items-center border-t border-dashed border-gray-300 pt-2">
                             <div>दूरध्वनी क्र.-०२०-२६१३३०१४</div>
                             <div>Email :- worksnorth1@gmail.com</div>
                        </div>
                    </div>

                    <div className="mt-6 flex justify-end font-marathi font-bold">
                        <p>दिनांक : {new Date().toLocaleDateString('en-GB')}</p>
                    </div>

                    {/* Recipient */}
                    <div className="mt-6 font-marathi font-bold space-y-1 text-left">
                        <p>प्रति,</p>
                        <p>चेअरमन</p>
                        <p>साईनाथ मजूर सहकारी संस्था मर्यादित</p>
                        <p>मु.पो.आरणागाव,ता.शिरूर,जि.पुणे</p>
                    </div>

                    {/* Subject */}
                    <div className="mt-8 text-center font-marathi font-bold space-y-1">
                        <p className="underline underline-offset-4">विषय- नोंदणीकृत मजूर सहकारी संस्थांचे वर्गीकरण अ अकुशल.</p>
                        <p>संदर्भ- जिल्हा उपनिबंधक सहकारी संस्था पुणे (ग्रामीण ) पत्र</p>
                        <p>जा.क्रं.जिउनिग्रा/ १०३४४ /मजूर/ साईनाथ मजूर सहकारी संस्था मर्यादित/२०२२ / दिनांक</p>
                    </div>

                    {/* Content */}
                    <div className="mt-8 font-marathi text-sm font-bold text-gray-800 space-y-6 text-justify leading-relaxed">
                        <p>महोदय,</p>
                        
                        <p className="indent-12">
                            आपणास कळविणेत येते की, महाराष्ट्र शासन सार्वजनिक बांधकाम विभागाकडील शासन निर्णय क्रमांक.सीएटी २०१७/प्रक्र्.१०३/इमा.२ दिनांक २३.७. १८ व जिल्हा उपनिबंधक सहकारी संस्था पुणे ग्रामीण यांचे पत्र जा.क्रं.जिउनिग्रा/ १०३४४ /मजूर/ श्री साईनाथ मजूर सहकारी संस्था मर्यादित/२०२२ / दिनांक नुसार आपले संस्थेचे वर्ग अ अकुशल वर्गीकरण करणेत आलेले आहे.या वर्गीकरणा प्रमाणे आपण प्रत्येकी काम अंदाजपत्रकीय किंमत रक्कम रुपये ३०.०० लक्ष (तीस लक्ष)पर्यत घेणेस पातू आहात. वर्गीकरण दिनांक आदेश दिल्याचा तारखेपासून दिनांक पर्यंत खालील अटीप्रमाणे ग्राह्य धरणेत येईल.
                        </p>

                        <p>
                            प्रत्येक वर्षाच्या १५ मे पूर्वी आपल्या वर्गीकरणाचे पुनर्विलोकन करण्याकरीता वित्तीय स्थिती, व्यवस्थापकीय व तांत्रिक पात्रता व संस्थेचे कार्य केलेल्या कामाची व हाती असलेल्या कामांची यादी हया बाबी दर्शविणारे वार्षिक विवरणपत्र या कार्यालयास सादर केले पाहिजे.महाराष्ट्र राज्यामध्ये उक्त पाच वर्षाच्या कालावधीमध्ये आपण एकही कामाची निविदा भरली नाही तरी मान्यताप्राप्त वर्गीकरण संस्थेच्या यादीतून आपले नाव काढून टाकणेत येईल.प्रत्येक कामाची निविदा सादर करणेचे वेळी आपण आपल्या व त्या दिवशी हाती असलेली सर्व कामे निविदा दर्शित रक्कम तसेच त्या कामाच्या पुर्ततेची परिस्थिती हया बाबी सुस्पष्टपणे दर्शविणारे विवरणपत्र सादर केले पाहिजे.
                        </p>

                        <p>
                            वरील कालावधीनंतर आपल्या वर्गीकरणाचे नूतनीकरण करण्यासाठी दर्जाची क्षमता दर्शविणारे नवीन प्रमाणपत्र (जरूर त्या रकमेचे व संस्थेचे स्वतःचे निधीसह ) जिल्हा उपनिबंधक सहकारी संस्था पुणे यांचेकडील तसेच वरील अटी प्रमाणे माहिती आपले वर्गीकरणाची मुदत संपण्याआधी किमान तीन महिने आधी सादर करण्याची आपणास विनंती आहे.
                        </p>

                        <p>
                            वरील पैकी कोणत्याही अटींचे अनुपालन न केल्यास आपले वरील वर्गीकरण रद्द करण्यास पात्र होईल याची नोंद घ्यावी.
                        </p>
                    </div>

                    {/* Signature */}
                    <div className="mt-12 flex justify-end font-marathi font-bold text-center">
                        <div className="space-y-2">
                             <div className="h-10">
                                  <img src="/signature_placeholder.png" alt="" className="h-12 mx-auto mix-blend-multiply opacity-60" onError={(e) => e.target.style.display = 'none'} />
                             </div>
                             <div className="space-y-1">
                                <p className="text-base">कार्यकारी अभियंता (उत्तर)</p>
                                <p className="text-base">बांधकाम विभाग उत्तर</p>
                                <p className="text-base">जिल्हा परिषद पुणे</p>
                             </div>
                        </div>
                    </div>

                    {/* Footer / Copies */}
                    <div className="mt-16 text-left font-marathi text-[12px] font-bold text-gray-600 leading-relaxed max-w-3xl">
                        <p>प्रत- मा.मुख्य कार्यकारी अधिकारी, जिल्हा परिषद पुणे यांना माहितीसाठी सादर. प्रत-जिल्हा उपनिबंधक सहकारी संस्था पुणे (ग्रामीण ) यांचे पत्र जा.क्रं.जिउनिग्रा/ १०३४४ /मजूर/ साईनाथ मजूर सहकारी संस्था मर्यादित/२०२२ / दिनांक ला अनुसरून अग्रेषित.</p>
                    </div>
                </div>
            </div>

            <style>{`
                @media print {
                    .no-print {
                        display: none !important;
                    }
                    body {
                        background: white !important;
                    }
                    .print-container {
                        box-shadow: none !important;
                        border: none !important;
                        padding: 0 !important;
                        margin: 0 !important;
                        max-width: 100% !important;
                    }
                    .App {
                        margin: 0 !important;
                        padding: 0 !important;
                    }
                    @page {
                        margin: 1.5cm;
                    }
                }
                .font-marathi {
                    font-family: 'Hind', sans-serif;
                }
                @import url('https://fonts.googleapis.com/css2?family=Hind:wght@400;500;600;700&display=swap');
            `}</style>
        </EngineerLayout>
    );
};

export default EngineerGenerateCertificate;
